/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-21 14:08:20
 * @LastEditTime: 2022-03-21 14:11:47
 * @LastEditors: Yandong Hu
 * @Description: 
 */
import { atom } from "recoil";

export const LoadingTextState = atom({
    key: 'LoadingTextState',
    default: 'loading...'
});
export const LoadingVisibleState = atom({
    key: 'LoadingState',
    default: false
});

const loadingService = {
    LoadingTextState,
    LoadingVisibleState
}
export default loadingService;